// css文件中不要使用import
import '../css/reset.css';
import '../css/base.css';
import '../css/index.css';
import '../css/project.css';

// 基础
import './lib/object.assign';
import './lib/promise';
import './lib/base-util';

// 语言
require('./lang/index');

require('./seed');
require('./config');

import Home from './view/home';
import ShouHuPage from './view/shouhu';
import native from 'c-up-native';

let Game = {
    
    init: function() {
        let self = this;
        let app = new UpAct.AppBase({
            title: UpAct.lang.template('h5页面标题'),
        });
        this.app = app;
        app.on('getActInfo',(data)=>{
            let defaultAcid = self.getDefaultAcid();
            //self.countdown(defaultAcid);
            $.channel.on('goShouHu',function(data){
                self.goShouHu(data.uid,data.acid);
            })
            $.channel.on('goHome',function(uid){
                self.goHome(defaultAcid);
            })
            // let uid = 5025226;
            // self.goShouHu(uid,defaultAcid);
            // return;
            if (!UpAct.platform.isUplive) {
                self.goHome(defaultAcid);
                
            } else {
                native.getHostInfo({
                    complete: function(opt) {
                        //
                        self.goHome(defaultAcid);
                        // if (opt.uid > 0 && !location.hash) {
                        //     // 在直播间
                        //     self.goShouHu(opt.uid,defaultAcid);
                        // } else {
                        //     self.goHome(defaultAcid);
                        // }
                    },
                    errtip: function() {
                        self.goHome(defaultAcid);
                    }
                });
            }  
        });
        app.getActInfo();
    },
    goHome:function(acid){
        let homeApp = new Home(this.app.userToken,this.app.uid,acid);
        homeApp.renderHomePage();
    },
    goShouHu: function(hostId,acid){

        let shohuApp = new ShouHuPage(hostId,acid);
        shohuApp.render();
    },
    getDefaultAcid: function(){
        let acid = UpAct.CONFIG.acidConfig.acid[0].acid;
        let areaAcidConfig;
        if($.isArray(acid)){
            $.each(acid,function(index,item){
                if (item.uniqueId.indexOf(UpAct.lang.langType) > -1) {
                    areaAcidConfig = item;
                }
            });
        }else if(typeof acid == 'object'){
            areaAcidConfig = acid;
        }
        
        let areaAcids = UpAct.CONFIG.parseAcid(areaAcidConfig.acid);
        let acidArr = areaAcids.split(',');
        return Number(acidArr[0]);
    },
    countdown: function(acid){

        let mapObj= this.acidMap;
        let actInfo =  UpAct.actData[acid];
        if(actInfo.status == 1){

            let remainTime = actInfo.overallRanking.endTime - actInfo.serverTime;
            UpAct.countdown.on('end', function() {
                UpAct.notification.simple(UpAct.lang.template('今日榜单活动已结束'));
                setTimeout( function() {
                    location.reload();
                }, 2000);
            });
            UpAct.countdown.start(remainTime);
            UpAct.countdown.set("wrap",".countdown")
        }
    }
};

$.getScript(langUrl + '?t=' + (+ new Date()) , function(){
    UpAct.lang.init();
    $.channel.on('gameInit',function(){
        Game.init();
    })
    Game.init();
});

$(function () {
    var isPageHide = false;
    window.addEventListener('pageshow', function () {
        if (isPageHide) {
            window.location.reload();
        }
    });

    window.addEventListener('pagehide', function () {
        isPageHide = true;
    });
})


// WEBPACK FOOTER //
// ./js/app.js